"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerGeolocationLink = void 0;
const React = require("react");
const react_1 = require("react");
const geoCode_1 = require("../../../../../helpers/geoCode");
const Loader_1 = require("../../../../../components/base/atoms/Loader");
const Icon_1 = require("../../../../../components/base/atoms/Icon");
const colors_1 = require("../../../../../types/colors");
const useConfig_1 = require("../../../../../hooks/useConfig");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CustomerGeolocationLink");
const CustomerGeolocationLink = ({ onGeolocated }) => {
    const { googleApiKey } = (0, useConfig_1.useConfig)();
    const retrieveFunc = (0, geoCode_1.retrieveAddressDetailsFromLatLng)(googleApiKey);
    const [geoLocating, setGeolocating] = (0, react_1.useState)(false);
    return (React.createElement(Loader_1.Loader, { size: "lg", visible: geoLocating, text: "finding your location".toUpperCase(), isBlocking: true },
        React.createElement("div", { className: css("") },
            React.createElement("div", { className: css("container"), onClick: async () => {
                    setGeolocating(true);
                    retrieveFunc()
                        .then(onGeolocated)
                        .finally(() => setGeolocating(false));
                } },
                React.createElement(Icon_1.Icon, { name: "map-marker", variant: colors_1.TColorVariants.Primary }),
                React.createElement("div", { className: css("text") }, "use current location")))));
};
exports.CustomerGeolocationLink = CustomerGeolocationLink;
//# sourceMappingURL=index.js.map